import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { FormField, FIELD_TYPES } from '@techchange/components';
import { messages } from '../../i18n';

const propTypes = {

	/**
	 * The resource to display.
	 */
	resource: PropTypes.shape({

		/**
		 * The unique ID for the resource.
		 */
		id: PropTypes.string,

		/**
		 * The type of the resource.
		 */
		type: PropTypes.string,

		/**
		 * The ID for the default child resource to display.
		 */
		default_child_id: PropTypes.string,

		/**
		 * The list of children resources (if any).
		 */
		children: PropTypes.arrayOf(PropTypes.shape({

			/**
			 * The unique ID for the child resource.
			 */
			id: PropTypes.string.isRequired,

			/**
			 * The title of the child resource.
			 */
			title: PropTypes.string.isRequired,

		})),

	}),

	/**
	 * The form data.
	 */
	data: PropTypes.shape({

		/**
		 * The ID for the default child resource to display.
		 */
		default_child_id: PropTypes.string,

	}),

	/**
	 * Function to handle changes to the form data.
	 */
	onInputChange: PropTypes.func.isRequired,

};


const DefaultSettingsEditor = ({ resource, data, onInputChange }) => {

	const intl = useIntl();

	// Get a list of the children resources that can be made the default to display
	const defaultChildOptions = [{
		label: intl.formatMessage(messages.TC_COMPONENTS_GENERAL_FIELD_OPTION_NONE),
		value: ''
	}];

	if (resource.children) {

		for (let i = 0, len = resource.children.length; i < len; i++) {

			defaultChildOptions.push({
				label: resource.children[i].title,
				value: resource.children[i].id,
			});

		}

	}

	return (
		<Fragment>
			<FormField
				type={FIELD_TYPES.SELECT}
				name="default_child_id"
				label={intl.formatMessage(messages.TC_COMPONENTS_RESOURCE_SETTINGS_MODAL_FIELD_LABEL_TEXT_DEFAULT_CHILD)}
				options={defaultChildOptions}
				value={data.default_child_id}
				isEditing
				onChange={onInputChange} />
		</Fragment>
	);

};

DefaultSettingsEditor.propTypes = propTypes;

export default DefaultSettingsEditor;
